import classNames from 'classnames';
import * as React from 'react';
import shortid from 'shortid';

import { TextField } from 'components/Fields/Input';

type Props = {
  autoFocus?: boolean;
} & FilterProps;

type State = {
  value: nil | string;
};

class InputFilter extends React.Component<Props, State> {
  id: string;

  state = {
    value: '',
  };

  constructor(props: Props) {
    super(props);
    this.id = shortid();
    this.state = {
      value: props.value,
    };
  }

  onChange = (e: React.ChangeEvent<any>) => {
    const value = e.currentTarget.value;
    this.setState({
      value,
    });
  };

  keyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      this.applyFilter();
    }
  };

  applyFilter = () => {
    const { name } = this.props;
    const { value } = this.state;
    this.props.apply({ name, value });
  };

  clear = () => {
    this.setState({
      value: null,
    });
  };

  render() {
    const { name, label } = this.props;
    const { value } = this.state;
    return (
      <div className='filter-container'>
        <div className='form-group' onKeyUp={this.keyPress}>
          <TextField
            label={label}
            fullWidth
            id={this.id}
            value={`${!!value ? value : ''}`}
            errors={[]}
            name={name}
            onChange={this.onChange}
            autoFocus
          />
        </div>
        <div className='filter-control'>
          <span className={classNames('clear', { hidden: !value })} onClick={this.clear}>
            Clear
          </span>
          <span className='apply' onClick={this.applyFilter}>
            Apply
          </span>
        </div>
      </div>
    );
  }
}

export { InputFilter };
